// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1CXbe1l0cZtgFHCqCeNVbr","Body":"_3Pi5atKnRNC94Hr4B3-YdC","Group":"_2N7bZSK-JT47WtJ4QsOXmT","Title":"u2ykrsl_1VNgtbKHhWrVC","Column":"_3XLPs8tmnKPxafOv1cjTQ2","CheckboxWrap":"_1ZplbpiGpeqmnqxwEpbKCj","CustomCheckbox":"_11BOiWSRl-FSI0IununG8l","ActiveIcon":"_373Yg1XzNHrNs_HBEFXfWx","BlockIcon":"_3bL8t-p3d0LQmtfVDwqyRy","Footer":"_2Zy88X_YuHS3FNe_zt0nNp","Submit":"_3RUdKdqwHAYTEAqthe-GxY","Reset":"_3NeUfI4rico6yUwqN5mUW4","buttonIcon":"_3r87i7F96e_arMej2N0eTG"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/AntiFraudFilters/styles.module.css
// module id = 532
// module chunks = 0